export default __webpack_public_path__ + "static/creative_challenge_1-aee83d3a78505a05b5b8909e43f53a7a.svg";